export default __webpack_public_path__ + "static/media/Group8881.cfbe3d61.svg";